// extracted by mini-css-extract-plugin
export default {"marketing-banners":"V6Par"};